import { render, staticRenderFns } from "@/style-guide/partials/inline-spinner/inline-spinner.pug?vue&type=template&id=11d4d34a&scoped=true&lang=pug&external"
import script from "./inline-spinner.vue?vue&type=script&lang=ts"
export * from "./inline-spinner.vue?vue&type=script&lang=ts"
import style0 from "./inline-spinner.vue?vue&type=style&index=0&id=11d4d34a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d4d34a",
  null
  
)

export default component.exports